<div class="organization-unit-collaborations-items">
  <div *ngIf="itemsList.length > 0">
    <div id="news-articles-ref">
      <div id="news-articles" class="news-articles" #collaborationsItems>
        <div class="container">
          <!-- Articles List for the current page -->
          <div *ngIf="!isLoading" class="news-articles__list">
            <a
              *ngFor="let item of displayedItems"
              [href]="item.link"
              tabindex="0"
              [attr.aria-label]="item.title"
              target="_blank"
            >
              <div class="slide-min slide-min--list">
                <div class="slide-min__img">
                  <img
                    [src]="item.thumbnailImageLink"
                    width="675"
                    height="390"
                    alt=""
                  />
                </div>
                <a
                  class="slide-min__name slide-min__name--bold"
                  [href]="item.link"
                  tabindex="0"
                  [attr.aria-label]="item.title"
                  target="_blank"
                  >{{ item.title }}</a
                >
                <div class="slide-min__name">{{ item.subTitle }}</div>
              </div>
            </a>
          </div>

          <!-- Pagination Buttons -->

          <div
            *ngIf="totalPages > 1 && !isLoading"
            class="pagination-container"
          >
            <app-paginator
              [totalResults]="itemsList.length"
              [currentPage]="currentPage"
              [pageSize]="itemsPerPage"
              (pageChanged)="changePage($event)"
              [paginatorContainerClass]="classMap.list"
              [activeLiClass]="classMap.elementActive"
              [activeLinkClass]="classMap.page"
              [liClass]="classMap.element"
              [linkClass]="classMap.page"
              [rangeSize]="5"
            ></app-paginator>
          </div>

          <!-- Loading Spinner -->
          <app-mini-preloader *ngIf="isLoading"></app-mini-preloader>
        </div>
      </div>
    </div>
  </div>
</div>

<!--<nav
          aria-label="Pagination Navigation"
          *ngIf="totalPages > 1 && !isLoading"
        >
          <ul class="pagination pagination--mt">
            <li
              *ngFor="let page of getPaginationBullets(); let i = index"
              class="pagination__link"
              [class.active]="page === currentPage"
            >
              <a
                href="javascript:void(0);"
                (click)="changePage(page)"
                [attr.aria-label]="
                  page === currentPage
                    ? 'Page ' + page + ' of ' + totalPages + ', current page'
                    : 'Go to page ' + page + ' of ' + totalPages
                "
                [class.pagination__link_a]="true"
                [class.c-sliding-pagination__page--current]="
                  page === currentPage
                "
              >
                {{ page }}
              </a>
            </li>
          </ul>
        </nav>
        -->